import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { evaluateSurveyAction } from '../../features/evaluate-survey/evaluate-survey.actions';
import { evaluateSurveyFeature } from '../../features/evaluate-survey/evaluate-survey.reducer';
import { SafeHtmlPipe } from '../../pipes';
import { EvaluationContentType } from '../../services';
import { SurveyPageLogoComponent } from '../survey-page-logo/survey-page-logo.component';

@Component({
  selector: 'lib-evaluate-response',
  standalone: true,
  imports: [
    CommonModule,
    SurveyPageLogoComponent,
    MatIconModule,
    MatButtonModule,
    SafeHtmlPipe,
  ],
  templateUrl: './evaluate-response.component.html',
  styleUrls: ['./evaluate-response.component.scss'],
})
export class EvaluateResponseComponent {
  private store = inject(Store);

  readonly EvaluationContentType = EvaluationContentType;

  readonly vm$ = combineLatest({
    response: this.store.select(evaluateSurveyFeature.selectResponse),
  });

  restart() {
    this.store.dispatch(evaluateSurveyAction.restart());
  }
}
